// extracted by mini-css-extract-plugin
module.exports = {"container":"Install_container__1U1bf","input__wrapper":"Install_input__wrapper__L1gi5","install__alert":"Install_install__alert__3hZrC"};